import Service, { getCallApiFunction } from '../service'
import { FeedType } from '@/types/feed'

export type ParamsType = {
  type: FeedType['type']
  preferenceTag: string
  cursorId?: string
}
export type ResponseType = {
  feeds: FeedType[]
  hasMore: boolean
}
class FetchFollowFeedApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_FOLLOW_FEED'
    this.config = {
      url: '/v1/livemall/feed/follow/',
      method: 'GET',
      params,
    }
  }
}
export async function fetchFollowFeed(params: ParamsType): Promise<ResponseType> {
  return getCallApiFunction(new FetchFollowFeedApi(params))
}
